import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Declined' },
    { value: 2, label: 'Accepted' },
  ],
});
